import { BrowserRouter } from "react-router-dom";
import VspPortalProvider from "./store/VspPortalProvider";
import { Views } from "./views/Views";
import { useMsalAuthentication } from '@azure/msal-react';
import { InteractionType } from "@azure/msal-browser";
import CacheBuster from 'react-cache-buster';
import packageInfo from '../package.json';


const App: React.FC = () => {

  useMsalAuthentication( InteractionType.Redirect );

  return (

    <CacheBuster
      currentVersion={ packageInfo.version }
      isEnabled= {true }
      isVerboseMode={ true } // if true, the library writes verbose logs to console
      metaFileDirectory={ '.' } // if public assets are hosted somewhere other than root on your server
    >

      <VspPortalProvider>
          <BrowserRouter>
            <Views />
          </BrowserRouter>
      </VspPortalProvider>

    </CacheBuster>

  );

};

export default App;
